import { FC } from 'react';

import { LucideIcon, Trash2 } from 'lucide-react';

import { Button } from '../../../components/ui/Button';

interface Props {
    title: string;
    icon: LucideIcon;
    showClear: boolean;
    onClear: () => void;
}

export const DeliveryMethodSectionHeader: FC<Props> = ({
    title,
    icon: Icon,
    showClear,
    onClear,
}) => {
    return (
        <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
                <div className="flex h-7 w-7 items-center justify-center rounded-full bg-primary/10">
                    <Icon className="h-3.5 w-3.5 text-primary" />
                </div>
                <h3 className="font-medium">{title}</h3>
            </div>
            {showClear && (
                <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    onClick={onClear}
                    className="text-muted-foreground hover:text-destructive"
                >
                    <Trash2 className="mr-1 h-3.5 w-3.5" />
                    Очистити
                </Button>
            )}
        </div>
    );
};
